import { render } from "./ColliEntrataTable.vue?vue&type=template&id=1e8ef9ba&scoped=true"
import script from "./ColliEntrataTable.vue?vue&type=script&lang=js"
export * from "./ColliEntrataTable.vue?vue&type=script&lang=js"

import "./ColliEntrataTable.vue?vue&type=style&index=0&id=1e8ef9ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e8ef9ba"]])

export default __exports__